import React from 'react';
import Link from 'next/link';

import PropTypes from 'prop-types';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

import TickIcon from 'assets/icons/tick-blank.svg';

import classes from './CareerCard.module.scss';


const CareerCard = ({ data }) => {
    return (
        <div className={classes['wrapper']}>
            <Link href={`/career-path/${data.id}/${data.slug}`} className={classes['card']}>
                <img src={data.image} alt="Career Path" />
                {data?.is_enrolled && (
                    <div className={classes['enrolled']}>
                        <TickIcon />
                        Enrolled
                    </div>
                )}
                <div className='p-4'>
                    <h3>{data.name}</h3>
                    <div className={classes['description']} dangerouslySetInnerHTML={{ __html: data.description }}></div>
                    <div className='d-flex justify-content-between align-items-center' >
                        <span className={classes['course-count']}> {data.lecture_count} Courses</span>
                        <div className={classes['progress-wrapper']}>
                            {data?.is_enrolled && (
                                <Box sx={{ position: 'relative', display: 'inline-flex' }}>
                                    <CircularProgress
                                        variant="determinate"
                                        value={100}
                                        sx={{ color: '#e0e0e0', position: 'absolute' }}
                                    />
                                    <CircularProgress
                                        variant="determinate"
                                        value={data.completed_lecture_count / data.lecture_count * 100}
                                        sx={{ color: 'primary.main' }}
                                    />
                                    <Box
                                        sx={{
                                            top: 0,
                                            left: 0,
                                            bottom: 0,
                                            right: 0,
                                            position: 'absolute',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                        }}
                                    >
                                        <Typography
                                            variant="caption"
                                            component="div"
                                            sx={{ color: 'text.secondary' }}
                                        >
                                            {data.completed_lecture_count}
                                        </Typography>
                                    </Box>
                                </Box>
                            )}
                        </div>
                    </div>
                </div>
            </Link>
        </div >
    );
};

export default CareerCard;